import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkmaxvalue',
})
export class CheckmaxvaluePipe implements PipeTransform {
  transform(value: number): any {
    if (isNaN(value) === false && value <= 10) {
      // console.log("checkMaxvalue");
      return value;
    }
    // console.log("return 0");
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/checkmaxvalue.pipe.ts